// extracted by mini-css-extract-plugin
module.exports = {"root":"LeexiCall_root__2uQ4z","content":"LeexiCall_content__1AobZ","left":"LeexiCall_left__223QX","right":"LeexiCall_right__37nUm"};